import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import bowser from 'bowser';
import matchheight from 'jquery-match-height';
import PerfectScrollbar from 'perfect-scrollbar';
import {TweenMax, Power2,Power4, TimelineLite} from "gsap/TweenMax";
import BackgroundCheck from "./BackgroundCheck";
import Pjax from 'pjax';
import ImgFilter from './ImgFilter';

if(bowser.msie === true) {
	let version = 'ie_'+Math.floor(bowser.version);
	$('body').addClass('ie '+version);
}else if(bowser.msedge === true){
	$('body').addClass('edge');
}else if(bowser.firefox === true){
	$('body').addClass('ff');
}else if(bowser.tablet === true){
	$('body').addClass('tablet');
}
if(bowser.mobile === true){
	$('body').addClass('device--mobile');
	if(bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
}else{
	os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();

const home_intro = ()=>{
	const svgR = document.getElementById("home_intro-svg");
	if(!svgR) return;

	//パスの長さを要素に当てておく
	let paths = new Array();
	[].slice.call( document.querySelectorAll('path,line') ).forEach( function( path, i ) {
		paths[i] = path;
		let leng = paths[i].getTotalLength() + 30;
		paths[i].style.strokeDasharray = leng + ' ' + leng;
		paths[i].style.strokeDashoffset = leng;
	} );
	/**
	 * ref
	 * http://reiwinn-web.net/2017/06/07/tweenmax/
	 */

	const svgtl = new TimelineMax();
	svgtl
	.to('.filter-home-intro-above', .6, {
		left:'0%',
		delay:.2,
		ease: Power4.easeOut
	})
	.to('.filter-home-intro-below', .6, {
		right:"0%",
		ease: Power4.easeOut
	})
	.to('.home_intro-svg',.5,{
		autoAlpha:1
	})
	.to('.home_intro-svg path, .home_intro-svg line', 1.6, {
		'stroke-dashoffset':0,
		ease: Power1.easeOut,
		onUpdate:function(){
			TweenMax.set('.home_intro', {'background-color':"transparent"});
		},
		onComplete: function(){
			TweenMax.to('.home_intro-svg path', .6, {
				fill:"#fff",
				delay:0
			});
			TweenMax.to('.filter-home-intro-above', .4, {
				y:'-100%',
				delay:.6,
				ease: Power4.easeOut
			});
			TweenMax.to('.filter-home-intro-below', .4, {
				y:"100%",
				delay:.6,
				ease: Power4.easeOut,
				onComplete:function(){
					TweenMax.to('.home_intro',.2,{
						autoAlpha:0
					});
				}
			});
		}
	})
}
home_intro();

/**
 * home filterd img
 */
if($('#filter_img').length > 0){
	let imgfilter = new ImgFilter('filter_img','.home-main-contents-bg');
	imgfilter.exec();
	imgfilter.onResize();
}

/**
 * spnavi
 */
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();
/**
 * smooth scroll
 */
const sms = new SmoothScroll();
sms.exec();
/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
const link_icon = require('./link_icon');
link_icon();

/**
 * spnavi animation
 */
const sptl = new TimelineLite();
$('.js-spnavi-inner-contents-toggle').on('click',function(e){
	e.preventDefault();
	let index = $('.js-spnavi-inner-contents-toggle').index(this);

	let next = $('.js-spnavi-inner-contents').eq(index);

	let is_active_parent = false;
	if($('.js-spnavi-inner-contents').eq(index).hasClass('active')){
		is_active_parent = true;
	}

	$('.js-spnavi-inner-contents').fadeOut('400',function(){
		$('.js-stagger-op0').css({opacity:0});
		$('.js-spnavi-inner-contents').removeClass('active');
	});

	if(!is_active_parent){
		next.fadeIn('400',function(){
			sptl.staggerTo($(this).find('.js-stagger-op0'), .6, {opacity:1}, .2);
			next.addClass('active');
		});
		next.each(function(){
			let ps = new PerfectScrollbar($(this)[0],{
				maxScrollbarLength:40
			});
		});
	}
});

/**
 * dot animation
 */
const parabora1 = (obj,param)=>{
	let objX = param.x;
	let objY = 0.02 * (objX * objX);
	TweenMax.set(obj,{
		y:objY
	});
}

const parabora2 = (obj,param)=>{
	let objY = 100 - param.y;
	let objX =  0.02 * (objY * objY);
	TweenMax.set(obj,{
		x:objX
	});
}

const parabora3 = (obj,param)=>{
	let objY = 100 - param.y;
	let objX =  100 - (0.02 * (objY * objY));
	TweenMax.set(obj,{
		x:objX
	});
}

const dotAnimation = ()=>{
	const dottl = new TimelineMax();
	let dot1 = document.getElementById("dot1"),
	dot2 = document.getElementById("dot2"),
	dot3 = document.getElementById("dot3");

	TweenMax.set(dot2,{y:100});
	TweenMax.set(dot3,{y:100,x:100});

	dottl.to(dot1,.3,{
		x:50,
		delay:0.2,
		ease:Power4.easeInOut,
		autoAlpha:1,
		onUpdate: ()=>{
			parabora1(dot1,dot1._gsTransform);
		}
	}).to(dot2,.3,{
		y:50,
		ease:Power4.easeInOut,
		delay:0.2,
		autoAlpha:1,
		onUpdate: ()=>{
			parabora2(dot2,dot2._gsTransform);
		}
	}).to(dot3,.3,{
		y:50,
		ease:Power4.easeInOut,
		delay:0.2,
		autoAlpha:1,
		onUpdate: ()=>{
			parabora3(dot3,dot3._gsTransform);
		}
	}).to(dot1,.2,{
		scale:4,
		ease:Power4.easeInOut
	}).to(dot2,.2,{
		scale:3,
		ease:Power4.easeInOut
	}).to(dot3,.2,{
		scale:2,
		ease:Power4.easeInOut
	})
}
/**
 * load map
 */
const loadMAP = ()=>{
	let MAP = document.getElementById('map');
	if(!MAP) return;

	let myOptions = {
		zoom: 17,
		center: new google.maps.LatLng(GLOBAL_LAT,GLOBAL_LNG),
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		scaleControl: false,
		streetViewControl:false,
		mapTypeControl: false
	};

	let map = new google.maps.Map(MAP, myOptions);
	let marker = new google.maps.Marker({
		position: new google.maps.LatLng(GLOBAL_LAT, GLOBAL_LNG),
		map: map,
		title: GLOBAL_LNAME
	});
}
/**
 * load article pjax
 */
const load_article = ()=>{
	let tl = new TimelineMax();

	tl
	.set('.main-article',{
		display:'block'
	})
	.to('.main-article-filter.mod-left',.4,{
		x:0,
		y:'-50%',
		rotation:-3.5,
		ease: Power4.easeInOut
	})
	.to('.main-article-filter.mod-right',.4,{
		x:0,
		y:'-50%',
		rotation:-3.5,
		ease: Power4.easeInOut
	})
	.to('.main-article-inner',.3,{
		autoAlpha: 1,
		delay: 1,
		onComplete: function(){
			$('.js-desined-scrollbar').each(function(){
				let ps = new PerfectScrollbar($(this)[0],{
					maxScrollbarLength:40
				});
			});
			if($('.main-article-inner .animation-dot').length > 0){
				dotAnimation();
			}
			if($('.random_chars').length > 0){
				TweenMax.to('.random_chars',.8,{
					top:0,
					left:0,
					rotation:0,
					delay:0.3
				});
			}
			loadMAP();
		}
	});
}
load_article();
/**
 * bgcolor checker
 */
const background_check = ()=>{
	if($('.home-main-contents-bg').css('background-image') != 'none'){
		BackgroundCheck.init({
			targets: '.btn_sp_navi,.global_header-logo',
			images: '.home-main-contents-bg'
		});
	}
}
window.addEventListener('load',function(){
	background_check();
});
/**
 * pjax
 */
window.addEventListener('load',function(){
	const pjax = new Pjax({
		selectors: ["title", "#wrap"],
		elements: "a.js-pjax"
	});

	document.addEventListener('pjax:send', function(){
		$('body').addClass('now-loading');
		dotAnimation();
		if($('.spnavi').hasClass('active')){
			$('.btn_sp_navi').click();
		}
	});
	document.addEventListener('pjax:complete', function(){
		$('body').attr('class',$('[data-body-class]').data('body-class'));
		home_intro();
		if($('#filter_img').length > 0){
			let imgfilter = new ImgFilter('filter_img','.home-main-contents-bg');
			imgfilter.exec();
			imgfilter.onResize();
		}
		background_check();
		load_article();

	});
});
